import React from 'react';
import _ from 'lodash';
import GlobalFunction from './globalFunction';
import { Responsive, WidthProvider } from "react-grid-layout";

const ResponsiveGridLayout = WidthProvider(Responsive);

class BoxSelect extends React.PureComponent {
    static defaultProps = {
        className: "layout",
       
        //breakpoints: {lg: 1200, md: 996, sm: 768, xs: 480, xxs: 100},
        breakpoints: {lg: 250, md: 200, sm: 150, xs: 100, xxs: 50},
        //rowHeight: 20,
        //verticalCompact: false,
        compactType: null,
        preventCollision: true
      };
    constructor(props){
        super(props);
        this.state={
          items: [],
          ignoreChange: false,
          rowHeight: 1
        }
        //this.moduleAdded = this.moduleAdded.bind(this);
        //this.onAddItem = this.onAddItem.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.onDragStop = this.onDragStop.bind(this);
        this.onResizeStop = this.onResizeStop.bind(this);
        this.state.rowHeight= this.props.rowHeight;
    }

UNSAFE_componentWillReceiveProps(nextProps){
  //console.log(nextProps);
  //console.log(this.state.cols);
  //console.log(this.state.breakpoint);
  let a=20;

}
UNSAFE_componentWillMount() {
  let a=20;
}


    createElement(el) {
      //console.log ('el.i='+el.i+'- el.key:'+el.key)
  /*      const removeStyle = {
          position: "absolute",
          right: "2px",
          top: 0,
          cursor: "pointer"
        };
        */
        //const i = el.add ? "+" : el.i;
        let backgroundColor = GlobalFunction.getPaletteColour(el.colour);
        let color = GlobalFunction.getPaletteContrastColour(el.colour)
        let boxStyle={backgroundColor: backgroundColor, color: color}
 /*       if (el.colour==='primary') {
          boxStyle={backgroundColor: "#4479b2"}
        } else if (el.colour==='success') {
          boxStyle={backgroundColor: "#72b566"}
        } if (el.colour==='info') {
          boxStyle={backgroundColor: "#73b566"}
        } if (el.colour==='warning') {
          boxStyle={backgroundColor: "#e7af5f"}
        } if (el.colour==='danger') {
          boxStyle={backgroundColor: "#cb5b54"}
        } if (el.colour==='default') {
          boxStyle={backgroundColor: "black"}
        } */
        el.minW = parseInt(el.min_width, 10);
        el.minH = parseInt(el.min_height, 10);


        return (
          <div style={boxStyle} key={el.key} data-grid={el}>
            {el.description}

          </div>
        );
      }

    // We're using the cols coming back //from this to calculate where to add new items.
    onBreakpointChange(breakpoint, cols) {
      this.setState({
          breakpoint: breakpoint,
          cols: cols
      });
    }
       


    
    onDragStop(layout, oldItem, newItem,
        placeholder, e, element) {

        // make sure we haven't moved it outside of our screen boundaries
        if ((newItem.y + newItem.h) <= this.props.selectedScreen.maxRows){
            this.props.itemChanged(newItem);
        } else {
          newItem.y=oldItem.y;
          newItem.h=oldItem.h;
        }
    }   


 
    onResizeStop(layout, oldItem, newItem,
        placeholder, e, element) {
    
      // make sure we haven't moved it outside of our screen boundaries
      if ((newItem.y + newItem.h) <= this.props.selectedScreen.maxRows){
        this.props.itemChanged(newItem);
      } else {
        newItem.y=oldItem.y;
        newItem.h=oldItem.h;
      }
      
    }

    onLayoutChange(layout) {

      //this.setState({ layout: layout });
    }
  
    onRemoveItem(i) {
      //console.log("removing", i);
      this.setState({ items: _.reject(this.state.items, { i: i }) });
    }



    render(){
      // mobilePortrait - 4 cols * 10 rows
      // mobileLandscape - 8 cols * 5 rows
      // tablet 8 cols * 13 rows
      // desktop 12 cols * 12 rows
      let cols={}
      let column=12;
      if (typeof this.props.selectedScreen.maxCols!=="undefined") {
        column=this.props.selectedScreen.maxCols;
      }
      cols={ lg: column, 
             md: column, 
             sm: column, 
             xs: column, 
             xxs: column }
            
    
        return (
            <div>
                <ResponsiveGridLayout
                    onLayoutChange={this.onLayoutChange.bind(this)}
                    onBreakpointChange={this.onBreakpointChange}
                    onDragStop={this.onDragStop}
                    cols={cols}
                    onResizeStop={this.onResizeStop}
                    rowHeight={this.state.rowHeight}
                    {...this.props}
                    >
                    {_.map(this.props.items, el => this.createElement(el))}
                </ResponsiveGridLayout>
            </div>
        )
  }
}


export default BoxSelect;    



